import { createStore } from "redux";
import rootReducer from "./CustomReducer";

const localHostnames = ["localhost", "127.0.0.1", "::1"];
const isAllowedDevToolsOrigin = typeof window !== "undefined" && (
	localHostnames.includes(window.location.hostname) ||
	window.location.origin === "https://connectd.uhaul.net"
);
const devToolsEnhancer = isAllowedDevToolsOrigin &&
	typeof window.__REDUX_DEVTOOLS_EXTENSION__ === "function"
	? window.__REDUX_DEVTOOLS_EXTENSION__()
	: undefined;

export default createStore(rootReducer, devToolsEnhancer);